import type { ReactNode } from "react";

interface LegalBlockProps {
  title: string;
  children: ReactNode;
}

export default function LegalBlock({ title, children }: LegalBlockProps) {
  return (
    <section className="border-t border-foreground-200 py-7">
      <h2 className="font-heading text-[16.5px] font-bold tracking-tight text-foreground-950 md:text-[18px]">
        {title}
      </h2>
      <div className="mt-3 max-w-3xl space-y-3 text-[13.5px] leading-relaxed text-foreground-700">
        {children}
      </div>
    </section>
  );
}